import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleRight,
  faArrowLeft,
  faAt,
  faCheckCircle,
  faCommentAlt,
  faFilter,
  faList,
  faMapMarkerAlt,
  faTrashAlt,
  faUnlockAlt,
  faWifi,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle as farCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAngleRight,
  faArrowLeft,
  faAt,
  faCheckCircle,
  faCommentAlt,
  faFilter,
  faList,
  faMapMarkerAlt,
  faTrashAlt,
  faUnlockAlt,
  faWifi,
  farCheckCircle,
  faQuestionCircle,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./resources/assets/js/font-awesome.js